<script>
    export let title;
    export let position;
    export let reservation
</script>
<h3>{title}</h3>
<h4>Lieu : {position}</h4>
<p>Réservation : {@html reservation}</p>
